import { loadStripe } from "@stripe/stripe-js/pure";

let stripe = null;

export const getStripe = () => {
  if (!stripe) stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  return stripe;
};

export const isEmbedPath = (path) => /^\/embed(\/|$)/i.test(path || "");

if (typeof window !== "undefined" && !isEmbedPath(window.location.pathname)) getStripe();
